import API from './api';

export default class AffiliateUserApi {
  static getList(params) {
    return API.get('/advertisers/affiliate_users', params);
  }
}
